import View from '../../../Core/View.js';

class Navigation extends View {

	static CLASS_STATE_MENU_OPEN = 'navigation--open';

	initialize() {
		this.menuIsOpen = false;

		this.$el.find('.navigation__trigger').on('click', this.toggle.bind(this));
		//
		// var $itemsWithSubmenu = this.$el.find('.main-navigation__list-item--show-submenu');
		// $itemsWithSubmenu.on('mouseenter', this.onSubmenuShowed.bind(this));
		// $itemsWithSubmenu.on('mouseleave', this.onSubmenuHidden.bind(this));
	}

	toggle() {
		if (this.menuIsOpen) {
			this.close();
		} else {
			this.open();
		}
	}

	open() {
		if (this.menuIsOpen) {
			return;
		}

		this.$el.addClass(Navigation.CLASS_STATE_MENU_OPEN);
		this.menuIsOpen = true;

		this.signals.mobileMenuOpened.dispatch();
	}

	close() {
		if (!this.menuIsOpen) {
			return;
		}

		this.$el.removeClass(Navigation.CLASS_STATE_MENU_OPEN);
		this.menuIsOpen = false;

		this.signals.mobileMenuClosed.dispatch();
	}

	onSubmenuShowed() {
		this.signals.subnavigationShown.dispatch();
	}

	onSubmenuHidden() {
		this.signals.subnavigationHidden.dispatch();
	}

}
export default Navigation;


// WEBPACK FOOTER //
// ./js/Views/Templates/Navigation/Navigation.js